const getCardData = (processLabel, plantTask) => {

  const getValueOrDefault = (value, defaultValue = "-") =>
    value != null && value !== "" ? value : defaultValue;

  const formatTraySlot = (slot) => {
    if (slot?.ordinalNumber === null || slot?.ordinalNumber === undefined) return "-";
    if (slot.ordinalNumber == import.meta.env.VITE_ORDINALNUMBER_TRAY_ON_SEED_TABLE_SLOT)   return "S1";
    const floor = slot.floor === 1 ? "U" : "L";
    const shelf = (slot.ordinalNumberInShelf ?? 0) + 1;
    return `${floor}${shelf}`;
  };

  const formatTraySeedTable = (slot, traySlot) =>
    traySlot === "-" 
      ? "-" 
      : (slot?.seedingTable?.name?.toUpperCase() ?? "-");

  const formatPanelSlot = (slot) =>
    slot?.ordinalNumber != null
      ? slot.ordinalNumber + 1
      : "-";

  const isTableSlot = (seedTableValue) => seedTableValue !== "-";

  const plants = plantTask?.processPlantCount ?? 0;
  const harvestingProcedure = getValueOrDefault(plantTask?.harvestingProcedure?.replace(/([A-Z])/g, ' $1').trim());
  const seedType = getValueOrDefault(plantTask?.seedType?.commonName);

  const trayName = getValueOrDefault(plantTask?.tray?.name?.toUpperCase());
  const traySlotObj = plantTask?.tray?.location?.traySlot;
  const traySlot = formatTraySlot(traySlotObj);
  const traySeedTable = formatTraySeedTable(traySlotObj, traySlot);

  const panelName = getValueOrDefault(plantTask?.panel?.name?.toUpperCase());
  const panelSlotObj = plantTask?.panel?.location?.panelSlot;
  const panelSlot = formatPanelSlot(panelSlotObj);
  const panelSeedTable = getValueOrDefault(panelSlotObj?.seedingTable?.name?.toUpperCase());
  const wallName = getValueOrDefault(panelSlotObj?.wall?.name?.toUpperCase());

  const useTable = isTableSlot(panelSeedTable);
  const wallOrTable = useTable ? "Table" : "Wall";
  const wallOrTableValue = useTable ? panelSeedTable : wallName;
  const wallOrTableSlot = useTable ? "S1" : panelSlot;

  const label = processLabel?.toLowerCase();
  
  let headers = [];
  let values = [];

  switch (label) {
    case "discard":
      if (trayName !== "-") {
        headers = ["Plants", "Tray", "Table", "Slot"];
        values = [plants, trayName, traySeedTable, traySlot];
        break;
      }
      if (panelName !== "-") {
        headers = ["Plants", "Panel", wallOrTable, "Slot"];
        values = [plants, panelName, wallOrTableValue, wallOrTableSlot];
        break;
      }
      break;

    case "harvest":
      headers = ["Plants", "Panel", wallOrTable, "Slot", "Harvesting Procedure"];
      values = [plants, panelName, wallOrTableValue, wallOrTableSlot, harvestingProcedure];
      break;

    case "transplant":
      headers = ["Plants", "Tray", "Table", "Slot", "Panel", wallOrTable, "Slot"];
      values = [plants, trayName, traySeedTable, traySlot, panelName, wallOrTableValue, wallOrTableSlot];
      break;

    case "seed":
      headers = ["Plants", "Tray", "Table", "Slot", "Seed Type"];
      values = [plants, trayName, traySeedTable, traySlot, seedType];
      break;

    default:
      headers = [];
      values = [];
  }

  return { headers, values };
}
export default getCardData;